import type { PayloadAction } from '@reduxjs/toolkit';
import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';

import { feedApi } from '../api/feedApi';
import type { RecentWinItem } from './feedSlice';
import { feedActions } from './feedSlice';

const LAST_PLAYED_KEY = 'last_played_game';

function* fetchFeedSaga(): Generator {
  try {
    const items = (yield call(feedApi.getRecentWins)) as RecentWinItem[];
    yield put(feedActions.fetchFeedSuccess(items));
  } catch {
    yield put(feedActions.fetchFeedFailure());
  }
}

function persistLastPlayedSaga(action: PayloadAction<string>): void {
  localStorage.setItem(LAST_PLAYED_KEY, action.payload);
}

export function* feedWatcher(): Generator {
  yield takeLatest(feedActions.fetchFeedRequest.type, fetchFeedSaga);
  yield takeEvery(feedActions.setLastPlayed.type, persistLastPlayedSaga);
}
